import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import PersonalDataFile from "~/components/Table/TableRow/DefaultTableRow/items/PersonalDataFile";
import { IconMimeType } from "~/libs/resolveMemeType";
import s from "../EditorPersonalData.less";

export const getEditorPersonalDataColumns = (
  t: TFunction,
  options: string[]
): ColumnsType<any> =>
  options.map((option) => {
    const base = {
      title: t(`personal_data.${option}`),
      dataIndex: option,
      key: option,
      render: (value: any, record: any) => {
        if (option === "personalDataTemplate") {
          if (!record?.File) {
            return <span />;
          }
          return (
            <div onClick={(e) => e.stopPropagation()}>
              <PersonalDataFile item={record} IconMimeType={IconMimeType} />
            </div>
          );
        }
        return <span>{value}</span>;
      },
    };

    if (option === "personalDataTemplate") {
      return {
        ...base,
        title: (
          <span className={s.templateHeaderTitle}>
            {t(`personal_data.${option}`)}
          </span>
        ),
        className: s.colPersonalDataTemplate,
        width: 88,
        align: "center" as const,
      };
    }

    return base;
  });
